<div class="dashboard-header">
  <div class="dashboard-info">
    <h2>Dashboard</h2>
    <p>
      Executive overview across your assessments, sessions, and integrity
      signals.
    </p>
  </div>

  <button class="add-assessment-btn" routerLink="/proctoring-dashboard/proto-assessment"
    *hasPermission="PermissionForStudents.PROCTORING_ASSESSMENT">
    View Assessments
  </button> 
</div>
<hr class="dashboard-divider" />

<div class="summary-cards">
  <ng-container *hasPermission="PermissionForStudents.PROCTORING_ASSESSMENT">
   <div class="summary-card">
    <div class="card-content">
      <span class="card-title">TOTAL ASSESSMENTS CONFIGURED</span>
      <h2>{{ assessmentCount }}</h2>
    </div>
    <div class="card-icon">
      <i class="bi bi-file-earmark-text"></i>
    </div>
  </div> 
  </ng-container>

  <div class="summary-card">
    <div class="card-content">
      <span class="card-title">TOTAL PROCTORED SESSIONS</span>
      <h2>{{ totalCandidates }}</h2>
    </div>
    <div class="card-icon">
      <i class="bi bi-camera-video"></i>
    </div>
  </div>
</div>

<app-proctoring-candidates (totalCandidateChange)="updateCount($event)"></app-proctoring-candidates>